/**
 * Translate MetricChart props into the exact per-series /api/metrics query
 * params. Pure and exported so the query construction is unit-tested without
 * mounting ECharts.
 */

import type { MetricBucket, MetricsParams } from '../api.js';
import { metricMeta } from '../metrics.js';

export interface ChartSeriesSpec {
  type: string;
  agg?: MetricsParams['agg'];
}

export interface ChartQueryInput {
  series: ChartSeriesSpec[];
  from: string;
  to: string;
  bucket: MetricBucket;
}

/**
 * One MetricsParams per series. Aggregation falls back to the metric's
 * canonical default (sum for cumulative counts, avg otherwise); raw buckets
 * ignore agg server-side but we still pass a coherent value.
 */
export function buildChartQueries(input: ChartQueryInput): MetricsParams[] {
  return input.series.map((s) => ({
    type: s.type,
    from: input.from,
    to: input.to,
    bucket: input.bucket,
    agg: s.agg ?? metricMeta(s.type).agg,
  }));
}
